import { Component } from 'react'
import PropTypes from 'prop-types'

import './ImageHeader.css'
import background from './images/background.jpg'

export class ImageHeader extends Component {
  static defaultProps = {
    className: '',
    bg: background.src
  }

  static propTypes = {
    className: PropTypes.string,
    bg: PropTypes.string
  }

  render() {
    return (
      <section
        className={`${this.props.className} image-header d-flex align-items-center`}
        style={{backgroundImage: `url(${this.props.bg})`}}>
        <div className="container">
          <div className="d-flex">
            <div className="col-xl-6 col-xl-8 col-lg-10 text-lg-left text-center p-0">
              {this.props.children}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export const ImageHeaderTitle = (props) => (
  <div className={`title d-flex align-items-center ${props.className || ''}`}>
    {props.children}
  </div>
)

export const ImageHeaderBrief = (props) => (
  <div className={`baseline mt-5 mb-4 pr-xl-5 pr-md-3 ${props.className || ''}`}>
    {props.children}
  </div>
)

export const ImageHeaderAction = (props) => (
  <div className={`action d-flex flex-wrap ${props.className || ''}`}>
    {props.children}
  </div>
)

export default ImageHeader